import React, { useState } from 'react';

import { images } from '../../constants';
import { AppWrap, MotionWrap } from '../../wrapper';
import { client } from '../../client';
import { useTranslation } from "react-i18next";
import './Footer.scss';

const Footer = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const { username, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    setLoading(true);

    const contact = {
      _type: 'contact',
      name: formData.username,
      email: formData.email,
      message: formData.message,
    };

    client.create(contact)
      .then(() => {
        setLoading(false);
        setIsFormSubmitted(true);
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <h2 className="head-text">{t('contactMe')}</h2>

      <div className="app__footer-cards">
        <div className="app__footer-card ">
          <img src={images.linkedin} alt="telegram" />
          <a href="https://linkedin.com/in/ekaterina-kutovaya" className="p-text" target="_blank" rel="noreferrer" >in/ekaterina-kutovaya</a>
        </div>

        <div className="app__footer-card ">
          <img src={images.telegram} alt="telegram" />
          <a href="https://t.me/ekaterina_kutovaya" className="p-text" target="_blank" rel="noreferrer" >t.me/ekaterina_kutovaya</a>
        </div>
        
        <div className="app__footer-card">
          <img src={images.mobile} alt="phone" />
          <a href="tel:+998909094511" className="p-text" target="_blank" rel="noreferrer">+ (998) 90 909 45 11</a>
        </div>

        {/* <div className="app__footer-card ">
          <img src={images.email} alt="email" />
          <a href="mailto:ekaterina@kutovaya.ru" className="p-text" target="_blank" rel="noreferrer">ekaterina@kutovaya.ru</a>
        </div> */}
      </div>
      {!isFormSubmitted ? (
        <div className="app__footer-form app__flex">
          <div className="app__flex">
            <input className="p-text" type="text" placeholder={t('yourName')} name="username" value={username} onChange={handleChangeInput} />
          </div>
          <div className="app__flex">
            <input className="p-text" type="email" placeholder={t('yourEmail')} name="email" value={email} onChange={handleChangeInput} />
          </div>
          <div>
            <textarea
              className="p-text"
              placeholder={t('yourMessage')}
              value={message}
              name="message"
              onChange={handleChangeInput}
            />
          </div>
          <button type="button" className="p-text" onClick={handleSubmit}>{!loading ? t('sendMessage') : t('sendingMessage')}</button>
        </div>
      ) : (
        <div>
          <h3 className="head-text">
              {t('sendSuccess')}
          </h3>
        </div>
      )}
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  'app__whitebg',
);
